import { container } from "tsyringe";
import "reflect-metadata";
import { OrdersClient } from "./ordersClient";
import { CreateOrderDto } from "../../generated-client";
import { UpdateOrderDto } from "@ang/shared-types";

export class OrdersService {
	private readonly orderClient: OrdersClient = container.resolve(OrdersClient);

	async getAllUserOrders() {
		return this.orderClient.ordersApi.ordersControllerGetAllUserOrders();
	}

	async getAllCompanyOrders() {
		return this.orderClient.ordersApi.ordersControllerGetAllCompanyOrders();
	}

	async createOrder(createOrderDto: CreateOrderDto) {
		return this.orderClient.ordersApi.ordersControllerCreateOrder({
			createOrderDto: createOrderDto,
		});
	}

	async updateOrder(docEntry: string, updateOrderDto: UpdateOrderDto) {
		return this.orderClient.ordersApi.ordersControllerUpdateOrder({
			docNum: docEntry,
			updateOrderDto: updateOrderDto,
		});
	}
}
